$(document).ready(function () {

  // 最新消息內頁, 分類頁
  if ( $('.wrap').data('page') == 'article_show' || $('.wrap').data('page') == 'posts-category') {
    const isCategoryPage = $('.wrap').data('page') == 'posts-category';
    // 文章相關頁面 - 側邊欄 快速導覽 h2 標題連結
    const $postSidemenu = $('.js-post-sidemenu');
    if ( $postSidemenu.length != 0 ) {
      let $postWrap = $('.js-post-content');
      if ( isCategoryPage ) {
        // 分類頁：每個子分類區塊就是一個 scrollspy 區塊
        updatePostH2DataForCategory($postWrap, $postSidemenu);
      } else {
        updatePostH2DataForShow($postWrap, $postSidemenu);
      }
    }
    if ( !isCategoryPage ) {
      var relatedServiceSwiper = new Swiper("#relatedServiceSwiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: `.related-service-next`,
          prevEl: `.related-service-prev`
        },
      });
    }
  }

  function updatePostH2DataForShow($postWrap, $postSidemenu) {
    // 抓取 h2 所在的目標容器
    let $post_h2_list = $postWrap.find('h2').not('.related-title');
    // h2 區塊的資訊
    let post_h2_data = [];
    function updatePostH2Data() {
      post_h2_data = [];
      $post_h2_list.each(function(index, h2) {
        let $h2 = $(h2);
        // h2 與下一個 h2 之間的內容包成一個 div.scrollspy
        let $section = $h2.closest('.scrollspy');
        if ($section.length == 0) {
          $section = $('<div class="scrollspy"></div>');
          let $nextH2 = $post_h2_list.eq(index + 1);
          let $siblings = $nextH2.length != 0 ? $h2.nextUntil($nextH2).addBack() : $h2.nextAll().addBack();
          $siblings.wrapAll($section);
          $section = $h2.closest('.scrollspy');
        }
        $section.attr('id', `h2-${index}`);
        post_h2_data.push({
          id: `h2-${index}`,
        })
      });
    }
    if ( $post_h2_list.length != 0 ) {
      // set h2
      updatePostH2Data();
      // set sidemenu
      $postSidemenu.each(function(i, sidemenu) {
        let $postSidemenuContent = $(sidemenu).find('.post-sidemenu-content'); // 內容容器
        $postSidemenuContent.append('<ul></ul>');
        // set link anchor
        $post_h2_list.each(function(index, el) {
          $postSidemenuContent.find('ul').append(`<li class="sidemenu-item" data-id="h2-${index}"><a class="scrollspy-link" href="#h2-${index}">${$(el).text()}</a></li>`);
        });
      })
    }
  }

  function updatePostH2DataForCategory($postWrap, $postSidemenu) {
    // 分類頁：每個子分類區塊為一個 scrollspy 區塊
    let $subcategoryBlocks = $postWrap.find('.subcategory-block');
    $subcategoryBlocks.each(function(index, block) {
      let $block = $(block);
      $block.addClass('scrollspy');
      $block.attr('id', `h2-${index}`);
    });
    if ( $subcategoryBlocks.length != 0 ) {
      // set sidemenu
      $postSidemenu.each(function(i, sidemenu) {
        let $postSidemenuContent = $(sidemenu).find('.post-sidemenu-content'); // 內容容器
        $postSidemenuContent.append('<ul></ul>');
        // set link anchor
        $subcategoryBlocks.each(function(index, block) {
          let $block = $(block);
          let title = $block.find('.title-inner').text().trim();
          $postSidemenuContent.find('ul').append(`<li class="sidemenu-item" data-id="h2-${index}"><a class="scrollspy-link" href="#h2-${index}">${title}</a></li>`);
        });
      })
    }
  }

});